import React, { useState, useEffect } from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import ClipLoader from "react-spinners/BounceLoader";
import getResponse from "./lib/getResponse";

export default function AccountInfo() {
  const [showOverlay, setShowOverlay] = useState(true);
  const [details, setDetails] = useState(null);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    getResponse(setShowOverlay, setDetails, setError, setMessage);
  }, []);

  if (error)
    return (
      <div className="orenda-frontend">
        <div className="loader message">
          <p>Unfortunately an error occured.</p>
        </div>
      </div>
    );

  if (showOverlay)
    return (
      <div className="orenda-frontend">
        <div className="loader bounce">
          <p>Please wait...</p>
          <ClipLoader size={30} />
        </div>
      </div>
    );

  if (message)
    return (
      <div className="orenda-frontend">
        <div className="loader message">
          <p>{message}</p>
        </div>
      </div>
    );

  return (
    <div className="orenda-frontend">
      <div className="info">
        <ListGroup>
          {Object.keys(details).map((x) => {
            return (
              <ListGroupItem>
                <div className={x + " description"}>{x}</div>
                <div className="value">{details[x]}</div>
              </ListGroupItem>
            );
          })}
        </ListGroup>
      </div>
    </div>
  );
}
